export enum enumDeliveryAdditionalService {
  CONSEGNA_AL_PIANO = 1,
  PREAVVISO_TELEFONICO = 2,
}
